import React, { ReactNode } from 'react'
import { motion } from 'framer-motion'

interface SkeletonListItemAnimationProps {
  reference: string
  children: ReactNode
}

export const SkeletonListItemAnimation = ({
  reference,
  children,
}: SkeletonListItemAnimationProps) => {
  return (
    <motion.li
      key={reference}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.15 }}
    >
      {children}
    </motion.li>
  )
}
